import { OutcomeExportFile } from "api/api-server-outcome-transfer";

export function countExportedOutcomes({ groups }: Pick<OutcomeExportFile, "groups">) {
  return groups.reduce(
    (total, group) =>
      total +
      group.outcomes.length +
      group.subgroups.reduce((subtotal, subgroup) => subtotal + subgroup.outcomes.length, 0),
    0,
  );
}
